import AutoComplete from './auto-complete.vue';
export default AutoComplete;



// WEBPACK FOOTER //
// ./src/components/auto-complete/index.js